import { render, staticRenderFns } from "./banner-hsia.vue?vue&type=template&id=10561dc0&scoped=true&"
import script from "./banner-hsia.vue?vue&type=script&lang=js&"
export * from "./banner-hsia.vue?vue&type=script&lang=js&"
import style0 from "./banner-hsia.vue?vue&type=style&index=0&id=10561dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10561dc0",
  null
  
)

export default component.exports